/*
  Cocktail Emporium theme scripts.
  Original Webflow / Udesly scripts stay untouched.
*/
(function () {
  document.documentElement.classList.add('ce-custom');

  document.addEventListener('DOMContentLoaded', function () {
    var $ = window.jQuery;
    if (!$) return;

    if (window.ga) {
      $('#privy-submit-btn').one('click', function () {
        window.ga('send', 'event', 'contact', 'submit', 'form');
      });
    }

    if ($.fn.marquee) {
      $('.marquee').marquee({
        duration: 15000,
        gap: 0,
        delayBeforeStart: 0,
        direction: 'left',
        duplicated: true,
        pauseOnHover: true
      });
    }

    function changeActiveSlide(obj) {
      $('.slide.active').removeClass('active');
      obj.addClass('active');
    }

    function changeActiveNumber(obj) {
      $('.number.active').removeClass('active');
      obj.addClass('active');
    }

    $('.number:not(.active)').on('click', function () {
      var selector = $('.number').index(this) + 1;
      changeActiveNumber($(this));
      changeActiveSlide($('.slide:nth-child(' + selector + ')'));
    });

    $('.number:first').addClass('active');

    if ($(window).width() > 991) {
      $('.left-menu-desktop .menu-item').mouseenter(function () {
        $('.global-nav-layover.active').removeClass('active');
        $('.navbar').removeClass('black');
        if ($(this).attr('id') != 'no-hover') {
          $('.navbar').addClass('black');
          var navID = '#' + $(this).attr('id') + '-nav';
          $(this).addClass('active');
          $(navID).addClass('active');
          $('.mega-menu-brand.w-nav-brand.w--current').fadeOut();
        }
      });

      $('.global-nav-layover').each(function () {
        var classes = ['green', 'pink', 'blue'];
        $(this).addClass(classes[~~(Math.random() * classes.length)]);
      });

      $('.gradient-bg').each(function () {
        var classes = ['green', 'pink', 'blue', 'lilac'];
        $(this).addClass(classes[~~(Math.random() * classes.length)]);
      });

      $('.global-nav-layover').mouseleave(function () {
        $('.navbar').removeClass('black');
        if ($('.menu-item.active')) {
          $('.global-nav-layover').removeClass('active');
          $('.menu-item').removeClass('active');
          $('.mega-menu-brand.w-nav-brand.w--current').fadeIn();
        }
      });
    }
  });
})();
